import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

/**
 * Mobile-first single-column shell for the Compass flow.
 * Uses the same Swiss brutalist tokens as the main app but with:
 *   - No sidebar
 *   - Generous padding
 *   - Large touch targets
 *   - Simple step indicator
 */
export default function CompassLayout({ children, back, step, total, testid }) {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid={testid || "compass-layout"}>
      <header className="sticky top-0 z-30 bg-background border-b-2 border-foreground">
        <div className="mx-auto max-w-2xl px-5 py-4 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 min-w-0">
            {back ? (
              <Link
                to={back}
                data-testid="compass-back"
                className="border-2 border-foreground p-2 hover:bg-foreground hover:text-background transition-colors flex-shrink-0"
                aria-label="Volver"
              >
                <ArrowLeft size={16} weight="bold" />
              </Link>
            ) : (
              <div className="display text-2xl leading-none">RUTA</div>
            )}
            <div className="label-mono text-muted-foreground truncate">Brújula</div>
          </div>
          {step && total && (
            <div className="flex items-center gap-1" data-testid="compass-step">
              {Array.from({ length: total }).map((_, i) => (
                <div
                  key={i}
                  className={`h-1.5 w-6 border-2 border-foreground ${i < step ? "bg-foreground" : "bg-background"}`}
                />
              ))}
            </div>
          )}
        </div>
      </header>

      <main className="mx-auto max-w-2xl px-5 py-6 md:py-10 pb-24">
        {children}
      </main>
    </div>
  );
}
